import { render, staticRenderFns } from "./selectShop.vue?vue&type=template&id=423a8d2d&scoped=true"
import script from "./selectShop.vue?vue&type=script&lang=js"
export * from "./selectShop.vue?vue&type=script&lang=js"
import style0 from "./selectShop.vue?vue&type=style&index=0&id=423a8d2d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "423a8d2d",
  null
  
)

export default component.exports